import {HttpCrudV2DataSource} from '../../../core/data-source/http-crud-v2.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {LoadingReportRecord} from './loading-report.record';

export default class LoadingReportCrudDataSource<T> extends HttpCrudV2DataSource<T> {
    protected apiPath: string = '/ui-api/loading-management/report';

    async getListReportData(date: string, params: any): Promise<any> {
        const query = Object.keys(params)
            .map((key) => {
                if (Array.isArray(params[key])) {
                    return params[key]
                        .map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                        .join('&');
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            })
            .join('&');
        return await fetch(`${this.apiPath}/${date}${query ? '?' + query : ''}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        }).then((response: any) => {
            return response.json().then((data: any) => {
                return data.map((item: any) => fromJson(LoadingReportRecord, item));
            });
        });
    }

    async export(date: string, params: any): Promise<any> {
        const query = Object.keys(params)
            .map((key) => {
                if (Array.isArray(params[key])) {
                    return params[key]
                        .map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                        .join('&');
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            })
            .join('&');
        const url: string = `${this.apiPath}/${date}/csv${query ? '?' + query : ''}`;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
